module.exports = "<section class=\"retailer store-profiles\">\r\n   <div class=\"content-view\">\r\n     <rw-subordinates-table on-retailer-click=\"$ctrl.onRetailerClick(subordinate)\">\r\n     </rw-subordinates-table>\r\n   </div>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/store-profiles/store-profiles.html
// module id = 1452
// module chunks = 0